import React from "react";
import { Box } from "../../styledSystemUtilities";
import { FlyersHero } from "../../Atoms/assets";
import { CopyWriting, Pen, Printer, Shipping, Strategy } from "../../Atoms";
import { Dimensions, GrayBackground, IconContainer, PricingNotes, SellingPoint } from "../../Molecules";
import { ProfitHeader } from "../../Molecules/PopupComponents";

export const PromotionalFlyers = ({ setPopup }) => {
    return (
        <Box width={"100%"}>
            <ProfitHeader setPopup={setPopup} Hero={FlyersHero} />
            <GrayBackground>
                <SellingPoint
                    header={"Expand the ways you educate your patients"}
                    body={
                        "We recommend using these flyers if you offer an in-house discount plan to your self-pay patients. It has plenty of real estate to sell all of the benefits. It can also be used to promote ancillary services."
                    }
                />
                <Dimensions bold={"8.5” x 11”"} light={"– 70 lb. paper"} />
                <SellingPoint
                    header={"Why Ascent for your promotional flyers?"}
                    body={
                        "• Better brand Integration\n" +
                        "• High-end, original design \n" +
                        "• We specialize in dental – It’s all we do\n" +
                        "• Smart strategy\n" +
                        "• Professional copywriting\n" +
                        "• It’s easier – We’re a one-stop-shop\n" +
                        "• Timely delivery"
                    }
                    lineHeight={"24px"}
                />
                <IconContainer name={"What's Included"}>
                    <Pen name={"Design"} />
                    <Strategy name={"Strategy"} fill={"balticBlue"} />
                    <CopyWriting name={"Copywriting"} fill={"balticBlue"} />
                    <Printer name={"Printing"} />
                    <Shipping name={"Shipping"} />
                </IconContainer>
            </GrayBackground>
            <PricingNotes>
                Print materials are purchased on a per-item basis and must be paid in full. We offer the choice of a
                1-time payment or 12 payments at a monthly interest rate of 12%.
            </PricingNotes>
        </Box>
    );
};
